import PodcastsIcon from '@mui/icons-material/Podcasts';

export const LoggerIcon = PodcastsIcon;
